import './navigation-new.css';

const WbcsSideMenu = () => {
  // close wbcs side menu clicking on close button
  const closeSideMenu = () => {
    const headerEl = document.querySelector('.main-header');
    headerEl.classList.toggle('hidden');
    const closebtn = document.querySelector('.navigation__sidemenu-st');
    closebtn.parentElement.classList.remove('sidemenu-open');
    const navMenuStudy = document.querySelector('.navigation__study');
    if (navMenuStudy.classList.contains('nav-open')) {
      navMenuStudy.classList.remove('nav-open');
    }
  };
  return (
    <div className="navigation__sidemenu-st">
      <span className="icon-close" onClick={closeSideMenu}>
        <ion-icon name="close-outline"></ion-icon>
      </span>
      <h2 className="heading-secondary">WBCS</h2>
      <hr />
      <ul className="navigation__sidemenu-list">
        <li>
          <a
            href="/wbcs/study-material-math"
            className="navigation__sidemenu-links"
          >
            Math
          </a>
        </li>
        <li>
          <a
            href="/wbcs/study-material-geography"
            className="navigation__sidemenu-links"
          >
            Geography
          </a>
        </li>
        <li>
          <a
            href="/wbcs/study-material-history"
            className="navigation__sidemenu-links"
          >
            History
          </a>
        </li>
        <li>
          <a
            href="/wbcs/study-material-general-science"
            className="navigation__sidemenu-links"
          >
            General Science
          </a>
        </li>
        <li>
          <a
            href="/wbcs/study-material-polity"
            className="navigation__sidemenu-links"
          >
            Polity(Indian Constitution)
          </a>
        </li>
        <li>
          <a
            href="/wbcs/study-material-economy"
            className="navigation__sidemenu-links"
          >
            Economy
          </a>
        </li>
        <li>
          <a
            href="/wbcs/study-material-gi"
            className="navigation__sidemenu-links"
          >
            GI
          </a>
        </li>
        <li>
          <a
            href="/wbcs/study-material-static-gk"
            className="navigation__sidemenu-links"
          >
            Static GK
          </a>
        </li>
        <li>
          <a
            href="/wbcs/study-material-ca"
            className="navigation__sidemenu-links"
          >
            CA
          </a>
        </li>
      </ul>
    </div>
  );
};

export default WbcsSideMenu;
